<template>
<div class="row no-gutters">
  <div class="col-lg-4 bg-gray full-height no-padding">
    <div class="event">
      <div class="event-header">
        <img class="bg-thumb" :src="eventInfo.imageUrl" />
        <div class="event-header-inner">
          <h1>{{eventInfo.title}}</h1>
          <h3>{{eventInfo.subtitle}}</h3>
        </div>
      </div>
      <div class="event-body">
        <p v-html="eventInfo.description">
        </p>

        <div class="row">

          <div class="col-2 text-center" style="font-size:25pt;"><font-awesome-icon icon="calendar" /></div>
          <div class="col-10">Veranstaltungsdatum<br/><b>{{eventDateTime}}</b></div>

        </div>

        <br/>

        <div class="row">

          <div class="col-2 text-center" style="font-size:25pt;"><font-awesome-icon icon="map-marker" /></div>
          <div class="col-4">Veranstaltungsort<br/><b>{{eventInfo.location}}</b></div>

          <div class="col-2 text-center" style="font-size:25pt;"></div>
          <div class="col-4">Preis<br/><b>{{eventInfo.price | stringifyNumber(',', 2)}} EUR</b></div>

        </div>

      </div>

    </div>
  </div>
  <div class="col-lg-8 enrollment">
    <div class="row enrollment-header">
      <div class="col-md-9">
        <h1>Ihre Anmeldung</h1>
        In vier einfachen Schritten zu Ihrer Buchung.<br/>
        Bitte füllen Sie dazu die folgenden Formulare aus:

      </div>
      <div class="col-md-3">
        <img src="https://tma-bensberg.de/wp-content/uploads/2015/10/tma-logo.png" class="logo" />
      </div>
    </div>
    <div class="row enrollment-body enrollment-success">
      <div class="col-md-12">
      <form-wizard
        shape="tab"
        color="#0091D1"
        @on-validate="handleValidation"
        back-button-text="Zum vorigen Schritt"
        next-button-text="Zum nächsten Schritt"
        finish-button-text="Zurück zu tma-bensberg.de"
        :start-index="3"
        @on-complete="onTabComplete"
        >
        <div slot="title"></div>
        <tab-content title="Buchungsinformationen">

        </tab-content>
        <tab-content title="Überprüfen Sie Ihre Daten">
         </tab-content>
         <tab-content title="Zahlungsinformationen">
          </tab-content>
         <tab-content title="Bestätigung">
           <h2>Herzlichen Dank für Ihre Buchung</h2>
           Eine Bestätigungsmail mit allen Informationen wurde soeben an Ihre E-Mail Adresse verschickt.
           <br/><br/>
           Ihre Thomas-Morus-Akademie Bensberg
         </tab-content>
      </form-wizard>
      </div>
    </div>
  </div>
</div>
</template>

<style lang="scss">
.event-header {
    width: 100%;
    position: relative;
}

.event-header .bg-thumb {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.event-header .event-header-inner {
    background-color: rgba(255,255,255,0.85);
    position: relative;
    width: 100%;
    height: 100%;
    padding: 50px;
}

.logo {
    float: right;
    width: 160px;
}

.event-body {
    padding: 50px;
}

.enrollment {
    padding: 50px !important;
}

.enrollment-header {
    border-bottom: 1px solid #DDD;
    padding-bottom: 30px;
    margin-bottom: 0px;
}

.btn-participant {
  margin-bottom:1px;
}
.enrollment-success .wizard-footer-left{
  display:none;
}
</style>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import VRPayPaymentForm from './../components/VRPayPaymentForm.vue'
import PartipantForm from './../components/Participant.vue'
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VueScript2 from 'vue-script2'

import moment from 'moment'
moment.locale('de');

export default {
  name: 'home',
  components: {
    FontAwesomeIcon,
    'payment-form': VRPayPaymentForm,
    'participant-form': PartipantForm,
    FormWizard,
    TabContent
  },
  data() {
    return {
      options: {
        height: '100%',
        size: 0
      },
      eventInfo: {},
      pMethods: {
        'creditcard': {
          brands: ['VISA', 'MASTER', 'AMEX'],
          title: 'Kreditkarte'
        },
        'debit': {
          brands: ['DIRECTDEBIT_SEPA'],
          title: 'SEPA-Lastschrift'
        }
      },
      customer: {},
      participants: []
    }
  },
  computed: {
    eventDateTime() {
      let momStart = moment(this.eventInfo.startDate);
      let momEnd = moment(this.eventInfo.endDate);

      if(momEnd.isAfter(momStart, 'day')) {
        if(momEnd.isSame(momStart, 'month')){
          return `${momStart.format('D.')} bis ${momEnd.format('D. MMMM Y')} (${momStart.format('dd.')}-${momEnd.format('dd.')})`
        }else{
          return `${momStart.format('D. MMMM')} bis ${momEnd.format('D. MMMM Y')} (${momStart.format('dd.')}-${momEnd.format('dd.')})`
        }
      }else{
        return `${momStart.format('D. MMMM Y')} (${momStart.format('dd.')})`
      }
    },
    calculateTotalPrice() {

      let price = (1+this.participants.length) * this.eventInfo.price;

      for(let i=0; i<this.participants.length; i++) {
        if(this.participants[i].overnight == false) {
          price-=this.eventInfo.overnightDiscount;
        }
      }

      return price;

    }
  },
  async beforeMount() {
    console.log("mounted");
    let result = await fetch(process.env.VUE_APP_BASE_URL+'/events/'+this.$route.params.postId, {})
    result = await result.json();

    this.eventInfo = result;
    sessionStorage.clear();
  },
  methods: {
    onTabComplete() {
      location.href = 'https://tma-bensberg.de';
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Success.vue